var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspectionsNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "2 4 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "InspectionsNav-a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v4824H0V0h1440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "InspectionsNav-b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.486 5.448a4.987 4.987 0 0 1 .823 5.964l2.399 2.4a.997.997 0 1 1-1.41 1.41l-2.297-2.298a4.986 4.986 0 1 1 .485-7.476ZM4.985 9.97a.997.997 0 0 1 0 1.994H.997a.997.997 0 0 1 0-1.994h3.988Zm5.86-3.112a2.99 2.99 0 1 0 4.23 4.23 2.99 2.99 0 0 0-4.23-4.23Zm-5.86-1.873a.997.997 0 0 1 0 1.994H.997a.997.997 0 1 1 0-1.994h3.988ZM16.949 0a.997.997 0 0 1 0 1.994H.997A.997.997 0 0 1 .997 0h15.952Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#InspectionsNav-a)",
    transform: "translate(-1037 -1472)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#InspectionsNav-b)",
    transform: "translate(1039 1476)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v15.514H0V0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionsNav);
export default __webpack_public_path__ + "static/media/InspectionsNav.5fd4a32a983960d54920985d2f7e4b89.svg";
export { ForwardRef as ReactComponent };